import { AccordionV2 } from '../accordion-v2';
import { FilterElement } from './FilterElement';
import { Filter, GroupedFilter, SetFilterValue } from './filter-types';

export const GroupFilterElement = ({
  filter,
  mode,
  visibleFilters,
  filterValues,
  clearCounts,
  allFilters,
  setFilterValue,
  removeFilter,
  display = 'col',
}: {
  filter: GroupedFilter;
  mode: string;
  visibleFilters: string[];
  filterValues: Record<string, unknown>;
  clearCounts?: Record<string, number>;
  allFilters: Filter[];
  setFilterValue: SetFilterValue;
  removeFilter: (filter?: Filter | undefined) => void;
  display?: 'row' | 'col';
}) => {
  const filtersRender = filter.elements
    .filter((filter) => visibleFilters.includes(filter.id))
    .map((filter) => {
      return (
        <FilterElement
          key={filter.id}
          filter={filter}
          filters={allFilters}
          mode={mode}
          filterValues={filterValues}
          clearCounts={clearCounts}
          setFilterValue={setFilterValue}
          removeFilter={removeFilter}
        />
      );
    });

  return (
    <AccordionV2
      expand={true}
      headingComponent={<h2 className="text-gray-500 dark:text-gray-400">{filter.groupLabel}</h2>}
      expandComponent={
        <div
          className={`inline-flex flex-${display} flex-wrap justify-start gap-2 overflow-y-visible p-2`}
        >
          {filtersRender}
        </div>
      }
    />
  );
};
